/* import mergeImages from "merge-images" */
import { getSelectedModel } from "../../hooks/use-selected-model.js"
import fusion from "./layerComposers/fusion.js"
import rapid60 from "./layerComposers/rapid60.js"
import rapid420 from "./layerComposers/rapid420.js"
import rapid120180 from "./layerComposers/rapid120180.js"

const prepareLayers = (values, currentArea) => {
  const modelsMap = {
    fusion: fusion,
    rapid60: rapid60,
    rapid120180: rapid120180,
    rapid420: rapid420,
  }
  const model = getSelectedModel()
  let layers = []

  layers = modelsMap[model](values, currentArea)

  return layers
}

export { prepareLayers }
